export const marketReportStatus = {
    coming: 0, //初始渲染，且还没有获取到数据 即 coming soon
    noLocation: 1, //  没有选择location 条件，不需要发起请求, 即提示用户选择location,优先级最高
    loading: 2, // 非初始渲染下，正在loading 数据
    loaded: 3 // 数据已成功请求
};
export const recentListingStatus = {
    coming: 0, //初始渲染，且还没有获取到数据 即 coming soon
    noLocation: 1, //  没有选择location 条件，不需要发起请求, 即提示用户选择location,优先级最高
    loading: 2, // 非初始渲染下，正在loading 数据
    loaded: 3 // 数据已成功请求
};
